import _extends from "@babel/runtime/helpers/extends";
import * as React from 'react';
function SvgTime(props) {
  return React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    preserveAspectRatio: "xMidYMid meet",
    stroke: props.stroke,
    fill: props.fill
  }, props), React.createElement("g", {
    stroke: "inherit",
    strokeWidth: 2,
    fill: "none",
    fillRule: "evenodd"
  }, React.createElement("path", {
    d: "M23 12c0-6.075-4.925-11-11-11S1 5.925 1 12s4.925 11 11 11 11-4.925 11-11z"
  }), React.createElement("path", {
    d: "M12.486 4.243v9h-6"
  })));
}
const MemoSvgTime = React.memo(SvgTime);
export default MemoSvgTime;